var _rect, _g, _rect2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialFacebookSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 64,
    height: 64,
    rx: 10,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#social_facebook_square_svg__clip0_12971_3274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.5 32c0-8.837-7.163-16-16-16s-16 7.163-16 16c0 7.503 5.166 13.8 12.135 15.529v-10.64h-3.3V32h3.3v-2.107c0-5.446 2.465-7.97 7.811-7.97 1.014 0 2.763.2 3.479.398v4.432c-.378-.04-1.034-.06-1.849-.06-2.623 0-3.637.994-3.637 3.578V32h5.226l-.898 4.89H34.44v10.993C42.362 46.926 48.501 40.18 48.501 32H48.5z",
    fill: "#0866FF"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.25,
    width: 63.5,
    height: 63.5,
    rx: 9.75,
    stroke: "#000",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "social_facebook_square_svg__clip0_12971_3274"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(16.5 16)",
    d: "M0 0h32v32H0z"
  })))));
}

export default SvgSocialFacebookSquare;